<div class="onboarding-page">
    <div class="onboarding-lang">
        <languages-translate-fuse [updateBundle]="false"></languages-translate-fuse>
    </div>

    <div class="onboarding-logo">
        @if (brand === 'flashlevel') {
        <img [src]="flashlevelLogoUrl" alt="FlashLevel">
        } @else {
        <img [src]="lilateLogoUrl" alt="LILATE">
        }
    </div>

    @if (showProgress) {
    <div class="onboarding-progress">
        <div class="onboarding-progress-track">
            <div class="onboarding-progress-fill" [style.width.%]="progressPercent"></div>
        </div>
        @if (progressLabel) {
        <div class="onboarding-progress-label">{{ progressLabel }}</div>
        }
    </div>
    }

    <div class="onboarding-card" [class.onboarding-card--wide]="wideCard">
        <ng-content></ng-content>
    </div>
</div>
